import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class fieldEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Field</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="idField" class="form-label form-label form-label-box">Field ESP ID</label>
                        <input type="text" class="input-text" data-bind="value: idField">
                    </div>
                    <div class="form-group row">
                        <label for="label" class="form-label form-label form-label-box">Field Label</label>
                        <input type="text" class="input-text" data-bind="value: label">
                    </div>
                    <div class="form-group row">
                        <label for="type" class="form-label form-label-box">Field Type</label>
                        <select name="" id="" data-bind="value: type">
                            <option disabled selected value>Select</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="email">Email</option>
                            <option value="number_box">Number Box</option>
                            <option value="text_box">Text Box</option>
                        </select>
                    </div>
                </div>
            </div>
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idField: ko.observable("")
            , label: ko.observable("")
            , type: ko.observable("")
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();

            },onClickSave: function (data, event) {
                self.onClickSave()
            }
        }
    }

    protected getTemplateName(): string {
        return "fieldEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setIdField(idField){
        this.getTemplateViewModel().idField(idField)
    }

    public setLabel(label){
        this.getTemplateViewModel().label(label)
    }

    public setType(type){
        this.getTemplateViewModel().type(type)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/fieldEdit_template.ts